import BooleanDropdown from './BooleanDropdown';

export default BooleanDropdown;
